import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import PageHeader from "@/components/feature/PageHeader";
import { cpLines } from "@/mocks/cpLines";

export default function CpLines() {
  return (
    <>
      <Navbar />
      <main>
        <PageHeader
          eyebrow="CP LINES"
          title="CP 线发展脉络"
          subtitle="从初遇结怨到并肩而行，各 CP 线按节点分集梳理。追更前读懂每条线的关系走向，名场面一个都不错过。"
          crumbs={[{ label: "首页", path: "/" }, { label: "CP 线" }]}
          image="https://readdy.ai/api/search-image?query=Romantic%20red%20threads%20and%20gold%20light%20connecting%20silhouettes%20of%20two%20cultivators%20across%20misty%20mountains%20at%20sunset%2C%20Chinese%20ink%20wash%20style%2C%20warm%20vermilion%20and%20gold%2C%20symbolic%20fate%20bonds%2C%20cinematic%2C%20refined%20detail&width=1920&height=760&seq=page-cp-01&orientation=landscape"
        />

        <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            {cpLines.map((cp) => (
              <article key={cp.id} className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
                <div className="relative h-52 w-full overflow-hidden">
                  <img src={cp.cover} alt={`${cp.name} CP线发展脉络封面`} className="h-full w-full object-cover" />
                  <span className="absolute left-3 top-3 rounded-full bg-background-950/70 px-3 py-1 text-xs text-accent-200 backdrop-blur">
                    {cp.tag}
                  </span>
                </div>

                <div className="p-6">
                  <div className="flex items-center justify-between">
                    <h2 className="font-heading text-xl text-foreground-950">{cp.name}</h2>
                    <span className="text-xs text-foreground-500">{cp.pairing}</span>
                  </div>

                  <div className="mt-4">
                    <div className="flex items-center justify-between text-xs text-foreground-600">
                      <span>读者热度</span>
                      <span className="text-primary-600">{cp.heat}%</span>
                    </div>
                    <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-background-200">
                      <div className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500" style={{ width: `${cp.heat}%` }}></div>
                    </div>
                  </div>

                  <p className="mt-4 text-sm leading-6 text-foreground-600">{cp.summary}</p>

                  <h3 className="mt-5 flex items-center gap-2 font-heading text-base text-foreground-950">
                    <i className="ri-route-line text-secondary-600" /> 发展脉络
                  </h3>
                  <div className="mt-4 space-y-0">
                    {cp.stages.map((s, i) => (
                      <div key={s.stage} className="relative flex gap-4 pb-5 last:pb-0">
                        {i < cp.stages.length - 1 && (
                          <span className="absolute left-[7px] top-7 h-full w-px bg-background-200"></span>
                        )}
                        <span className="mt-1 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-accent-500 ring-4 ring-accent-500/15"></span>
                        <div>
                          <div className="flex items-center gap-2">
                            <span className="text-xs font-medium text-primary-600">
                              阶段 {String(i + 1).padStart(2, "0")}
                            </span>
                            <h4 className="text-sm font-semibold text-foreground-950">{s.stage}</h4>
                          </div>
                          <p className="mt-1 text-xs leading-6 text-foreground-600">{s.desc}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="mt-12 rounded-lg border border-background-200 bg-background-100 p-8 text-center">
            <h2 className="font-heading text-xl text-foreground-950">想看懂 CP 线的伏笔？</h2>
            <p className="mx-auto mt-3 max-w-xl text-sm leading-7 text-foreground-600">
              每条 CP 线的发展都建立在人物关系的亲疏之上。先厘清师兄关系与师姐互动，再回看这些脉络会更有味道。
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              <Link
                to="/relations"
                className="whitespace-nowrap rounded-md bg-primary-500 px-7 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600"
              >
                返回人物关系图
              </Link>
              <Link
                to="/daily"
                className="whitespace-nowrap rounded-md border border-primary-200 px-7 py-3 text-sm text-primary-700 transition-colors hover:bg-primary-50"
              >
                逛逛师门日常
              </Link>
            </div>
          </div>
        </section>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "CollectionPage",
              name: "CP 线发展脉络",
              description: "师兄啊师兄各 CP 线从初遇结怨到并肩而行的发展脉络梳理。",
              inLanguage: "zh-CN",
              about: "师兄啊师兄 CP 线",
            }),
          }}
        />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}